<header class="navbar-v2-outer">
  <nav class="navbar-v2-container">
    <div class="navbar-logo">
      <a href="/new-home">
        <svg
          *ngIf="!darkNav || (darkNav && isOpen)"
          width="133"
          height="25"
          viewBox="0 0 133 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M23.889 0.977051V23.4712H19.2994V16.7321C19.2994 13.117 19.3984 9.31789 19.5966 5.33476C18.8889 8.2399 18.1364 10.863 17.3394 13.2041L13.8865 23.4712H10.0874L6.53656 13.4132C5.63711 10.7966 4.88676 8.13106 4.28911 5.42949C4.47857 9.83729 4.57331 13.4306 4.57331 16.2094V23.4712H0V0.977051H6.86649L10.1789 10.7476C10.9443 13.0783 11.5586 15.4559 12.018 17.8656C12.508 15.4408 13.1429 13.0475 13.9192 10.6986L17.0748 0.977051H23.889Z"
            fill="#FAF2F2"
          />
          <path
            d="M47.3203 0.977051H57.2444C59.2044 0.977051 60.707 1.31678 61.7524 1.99625C63.5403 3.14611 64.4332 4.9297 64.431 7.34702C64.431 9.04785 63.9552 10.4471 63.0035 11.5447C62.5082 12.123 61.8791 12.5715 61.1709 12.8513C61.6176 12.9723 62.0356 13.1815 62.4003 13.4664C62.7649 13.7514 63.0689 14.1065 63.2942 14.5108C63.7353 15.3257 64.0076 16.2212 64.0946 17.1437C64.1446 17.4638 64.2416 18.5124 64.3853 20.2895C64.5116 21.8553 64.7152 22.8353 64.9961 23.2295L65.1856 23.4843H60.5176C60.3765 23.1619 60.2735 22.8243 60.2105 22.4781C60.143 22.1384 60.0406 20.9308 59.9034 18.8554C59.7684 17.0021 59.2893 15.788 58.4661 15.2131C57.9108 14.832 57.0277 14.6404 55.8169 14.6382H51.7891V23.4712H47.3203V0.977051ZM51.7891 4.83823V11.0449H56.0357C57.4143 11.0449 58.3845 10.8271 58.9463 10.3915C59.6563 9.84927 60.0102 9.02498 60.008 7.91868C60.008 6.59895 59.5278 5.69954 58.5674 5.22043C57.8291 4.92536 57.0356 4.79386 56.2415 4.83496L51.7891 4.83823Z"
            fill="#FAF2F2"
          />
          <path
            d="M70.8801 0.977051H66.2578V23.4712H70.8801V0.977051Z"
            fill="#FAF2F2"
          />
          <path
            d="M91.5381 0.977051V23.4712H86.9125V13.6843H78.2232V23.4712H73.5977V0.977051H78.2232V9.51934H86.9125V0.977051H91.5381Z"
            fill="#FAAD14"
          />
          <path
            d="M112.468 1.24811V14.5466C112.468 16.4609 112.302 17.9407 111.971 18.986C110.856 22.5249 108.009 24.2943 103.429 24.2943C100.959 24.2943 99.022 23.8152 97.6173 22.857C96.1321 21.8577 95.0859 20.3276 94.6937 18.5809C94.4065 17.2385 94.2804 15.8666 94.318 14.4944V1.24811H98.9403V14.8014C98.9403 16.5175 99.1766 17.7469 99.6492 18.4895C100.37 19.6306 101.66 20.2001 103.52 20.1979C105.262 20.1979 106.46 19.66 107.113 18.5842C107.597 17.8089 107.839 16.548 107.839 14.8014V1.24811H112.468Z"
            fill="#FAAD14"
          />
          <path
            d="M114.939 1.24811H124.485C126.523 1.24811 128.047 1.52468 129.058 2.07784C129.987 2.57353 130.736 3.34974 131.198 4.29589C131.607 5.10579 131.819 6.0015 131.815 6.90921C131.84 8.12595 131.426 9.31092 130.649 10.2477C130.185 10.8037 129.604 11.2499 128.947 11.5544C129.594 11.7717 130.207 12.0785 130.77 12.4658C132.144 13.5307 132.832 15.0845 132.834 17.1273C132.888 18.7558 132.317 20.3433 131.237 21.5634C129.93 23.0225 127.97 23.752 125.357 23.752H114.939V1.24811ZM119.562 5.11255V10.3653H123.808C124.791 10.3653 125.514 10.2423 125.977 9.99619C126.849 9.54757 127.284 8.78535 127.284 7.70954C127.284 6.61521 126.863 5.85735 126.02 5.44248C125.569 5.22471 124.831 5.11582 123.805 5.11582L119.562 5.11255ZM119.562 13.7169V19.8778H124.262C125.6 19.8778 126.538 19.6753 127.078 19.2702C127.804 18.7279 128.163 17.9047 128.163 16.7974C128.163 15.4776 127.676 14.5782 126.703 14.0991C126.17 13.8443 125.278 13.7169 124.021 13.7169H119.562Z"
            fill="#FAAD14"
          />
          <path
            d="M26.6699 23.7422V10.4436C26.6699 8.5272 26.8365 7.04741 27.1697 6.00426C28.2847 2.46974 31.1311 0.703574 35.7087 0.705752C38.1783 0.705752 40.1165 1.18377 41.5234 2.13981C43.0124 3.138 44.0614 4.66987 44.4536 6.41912C44.7408 7.76153 44.867 9.13341 44.8292 10.5057V23.7422H40.2069V10.1888C40.2069 8.47493 39.9706 7.24558 39.4981 6.50079C38.7707 5.35964 37.4825 4.79015 35.6336 4.79233C33.8914 4.79233 32.6936 5.32915 32.0403 6.40279C31.559 7.18025 31.3184 8.44226 31.3184 10.1888V23.7422H26.6699Z"
            fill="#FAF2F2"
          />
          <path
            d="M40.8703 11.0349H28.7314V15.0561H40.8703V11.0349Z"
            fill="#FAF2F2"
          />
        </svg>
        <svg
          *ngIf="darkNav && !isOpen"
          width="133"
          height="25"
          viewBox="0 0 133 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M23.889 0.977051V23.4712H19.2994V16.7321C19.2994 13.117 19.3984 9.31789 19.5966 5.33476C18.8888 8.2399 18.1364 10.863 17.3394 13.2041L13.8865 23.4712H10.0874L6.53656 13.4132C5.63711 10.7966 4.88676 8.13106 4.28911 5.42949C4.47857 9.83729 4.57331 13.4306 4.57331 16.2094V23.4712H0V0.977051H6.8665L10.1789 10.7476C10.9443 13.0783 11.5586 15.4559 12.018 17.8656C12.508 15.4408 13.1429 13.0475 13.9192 10.6986L17.0748 0.977051H23.889Z"
            fill="#000614"
          />
          <path
            d="M47.3203 0.977051H57.2444C59.2044 0.977051 60.707 1.31678 61.7524 1.99625C63.5403 3.14611 64.4332 4.9297 64.431 7.34701C64.431 9.04785 63.9552 10.4471 63.0035 11.5447C62.5082 12.123 61.8791 12.5715 61.1709 12.8513C61.6176 12.9723 62.0356 13.1815 62.4003 13.4664C62.7649 13.7514 63.0689 14.1065 63.2942 14.5108C63.7353 15.3257 64.0076 16.2212 64.0946 17.1437C64.1446 17.4638 64.2416 18.5124 64.3853 20.2895C64.5116 21.8553 64.7152 22.8353 64.9961 23.2295L65.1856 23.4843H60.5176C60.3765 23.1619 60.2735 22.8243 60.2105 22.4781C60.143 22.1384 60.0406 20.9308 59.9034 18.8554C59.7684 17.0021 59.2893 15.788 58.4661 15.2131C57.9108 14.832 57.0277 14.6404 55.8169 14.6382H51.7891V23.4712H47.3203V0.977051ZM51.7891 4.83823V11.0449H56.0357C57.4143 11.0449 58.3844 10.8271 58.9463 10.3915C59.6563 9.84927 60.0102 9.02498 60.008 7.91868C60.008 6.59895 59.5278 5.69954 58.5674 5.22043C57.8291 4.92536 57.0356 4.79386 56.2415 4.83496L51.7891 4.83823Z"
            fill="#000614"
          />
          <path
            d="M70.8801 0.977051H66.2578V23.4712H70.8801V0.977051Z"
            fill="#000614"
          />
          <path
            d="M91.5381 0.977051V23.4712H86.9125V13.6843H78.2232V23.4712H73.5977V0.977051H78.2232V9.51934H86.9125V0.977051H91.5381Z"
            fill="#FAAD14"
          />
          <path
            d="M112.467 1.24808V14.5466C112.467 16.4609 112.301 17.9407 111.97 18.986C110.855 22.5248 108.008 24.2943 103.428 24.2943C100.958 24.2943 99.021 23.8152 97.6163 22.857C96.1311 21.8576 95.085 20.3275 94.6927 18.5809C94.4055 17.2385 94.2794 15.8666 94.317 14.4943V1.24808H98.9393V14.8014C98.9393 16.5175 99.1756 17.7468 99.6482 18.4894C100.369 19.6306 101.659 20.2001 103.519 20.1979C105.261 20.1979 106.459 19.66 107.112 18.5842C107.596 17.8089 107.838 16.548 107.838 14.8014V1.24808H112.467Z"
            fill="#FAAD14"
          />
          <path
            d="M114.939 1.24808H124.485C126.523 1.24808 128.047 1.52465 129.058 2.07781C129.987 2.5735 130.736 3.34971 131.198 4.29586C131.607 5.10576 131.819 6.00147 131.815 6.90918C131.84 8.12592 131.426 9.31089 130.649 10.2477C130.185 10.8036 129.604 11.2499 128.947 11.5544C129.594 11.7717 130.207 12.0784 130.77 12.4657C132.144 13.5307 132.832 15.0845 132.834 17.1273C132.888 18.7558 132.317 20.3432 131.237 21.5634C129.93 23.0225 127.97 23.752 125.357 23.752H114.939V1.24808ZM119.562 5.11252V10.3653H123.808C124.791 10.3653 125.514 10.2422 125.977 9.99616C126.849 9.54754 127.284 8.78532 127.284 7.70951C127.284 6.61518 126.863 5.85732 126.02 5.44245C125.569 5.22468 124.831 5.11579 123.805 5.11579L119.562 5.11252ZM119.562 13.7169V19.8778H124.262C125.6 19.8778 126.538 19.6752 127.078 19.2702C127.804 18.7279 128.163 17.9047 128.163 16.7973C128.163 15.4776 127.676 14.5782 126.703 14.0991C126.17 13.8443 125.278 13.7169 124.021 13.7169H119.562Z"
            fill="#FAAD14"
          />
          <path
            d="M26.6699 23.7422V10.4436C26.6699 8.5272 26.8365 7.04741 27.1697 6.00426C28.2847 2.46974 31.1311 0.703574 35.7087 0.705752C38.1783 0.705752 40.1165 1.18377 41.5234 2.13981C43.0124 3.138 44.0614 4.66987 44.4536 6.41912C44.7408 7.76153 44.867 9.13341 44.8292 10.5057V23.7422H40.2069V10.1888C40.2069 8.47493 39.9706 7.24558 39.4981 6.50079C38.7707 5.35964 37.4825 4.79015 35.6336 4.79233C33.8914 4.79233 32.6936 5.32915 32.0403 6.40279C31.559 7.18025 31.3184 8.44226 31.3184 10.1888V23.7422H26.6699Z"
            fill="#000614"
          />
          <path
            d="M40.8693 11.0349H28.7305V15.0561H40.8693V11.0349Z"
            fill="#000614"
          />
        </svg>
      </a>
    </div>
    <div *ngIf="!darkNav" class="nav-menu-container">
      <div class="nav-menu-outer">
        <button
          class="nav-menu-trigger"
          [matMenuTriggerFor]="solutionsMenu"
          #solutions="matMenuTrigger"
        >
          <div class="gap-6">
            <span class="">Solutions</span>
            <mat-icon class="material-icons-outlined filter-mat-icon">
              {{ solutions.menuOpen ? "expand_less" : "expand_more" }}
            </mat-icon>
          </div>
        </button>
        <mat-menu class="nav-v2-menu-panel" #solutionsMenu="matMenu">
          <div class="nav-v2-menu-inner">
            <a
              href="/solutions/marketplace"
              class="nav-v2-menu-item"
              mat-menu-item
            >
              <span class="">Marihub Marketplace</span>
            </a>
            <!-- <a
              href="/solutions/bluepass"
              class="nav-v2-menu-item"
              mat-menu-item
            >
              <span class="">BluePass</span>
            </a> -->
          </div>
        </mat-menu>
      </div>
      <!-- <div class="nav-menu-outer">
        <button
          class="nav-menu-trigger"
          [matMenuTriggerFor]="resourcesMenu"
          #resources="matMenuTrigger"
        >
          <div class="gap-6">
            <span class="">Resources</span>
            <mat-icon class="material-icons-outlined filter-mat-icon">
              {{ resources.menuOpen ? "expand_less" : "expand_more" }}
            </mat-icon>
          </div>
        </button>
        <mat-menu class="nav-v2-menu-panel" #resourcesMenu="matMenu">
          <div class="nav-v2-menu-inner">
            <a class="nav-v2-menu-item" mat-menu-item>
              <span class="">Case Studies</span>
            </a>
            <a class="nav-v2-menu-item" mat-menu-item>
              <span class="">Reports</span>
            </a>
            <a class="nav-v2-menu-item" mat-menu-item>
              <span class="">Articles</span>
            </a>
          </div>
        </mat-menu>
      </div> -->
      <div class="nav-menu-outer">
        <button
          class="nav-menu-trigger"
          [matMenuTriggerFor]="companyMenu"
          #company="matMenuTrigger"
        >
          <div class="gap-6">
            <span class="">Company</span>
            <mat-icon class="material-icons-outlined filter-mat-icon">
              {{ company.menuOpen ? "expand_less" : "expand_more" }}
            </mat-icon>
          </div>
        </button>
        <mat-menu class="nav-v2-menu-panel" #companyMenu="matMenu">
          <div class="nav-v2-menu-inner">
            <a href="aboutus" class="nav-v2-menu-item" mat-menu-item>
              <span class="">About us</span>
            </a>
            <!-- <a class="nav-v2-menu-item" mat-menu-item>
              <span class="">Leadership</span>
            </a>
            <a class="nav-v2-menu-item" mat-menu-item>
              <span class="">News</span>
            </a> -->
          </div>
        </mat-menu>
      </div>
    </div>
    <!-- Dark Theme -->

    <div *ngIf="darkNav" class="nav-menu-container">
      <div class="nav-menu-outer">
        <button
          class="nav-menu-trigger nav-menu-trigger--dark"
          [matMenuTriggerFor]="solutionsMenu"
          #solutions="matMenuTrigger"
        >
          <div class="gap-6">
            <span class="">Solutions</span>
            <mat-icon class="material-icons-outlined filter-mat-icon">
              {{ solutions.menuOpen ? "expand_less" : "expand_more" }}
            </mat-icon>
          </div>
        </button>
        <mat-menu class="nav-v2-menu-panel-dark" #solutionsMenu="matMenu">
          <div class="nav-v2-menu-inner">
            <a
              href="/solutions/marketplace"
              class="nav-v2-menu-item nav-v2-menu-item--dark"
              mat-menu-item
            >
              <span class="">Marihub Marketplace</span>
            </a>
            <!-- <a
              href="/solutions/bluepass"
              class="nav-v2-menu-item nav-v2-menu-item--dark"
              mat-menu-item
            >
              <span class="">BluePass</span>
            </a> -->
          </div>
        </mat-menu>
      </div>
      <!-- <div class="nav-menu-outer">
        <button
          class="nav-menu-trigger nav-menu-trigger--dark"
          [matMenuTriggerFor]="resourcesMenu"
          #resources="matMenuTrigger"
        >
          <div class="gap-6">
            <span class="">Resources</span>
            <mat-icon class="material-icons-outlined filter-mat-icon">
              {{ resources.menuOpen ? "expand_less" : "expand_more" }}
            </mat-icon>
          </div>
        </button>
        <mat-menu class="nav-v2-menu-panel-dark" #resourcesMenu="matMenu">
          <div class="nav-v2-menu-inner">
            <a class="nav-v2-menu-item nav-v2-menu-item--dark" mat-menu-item>
              <span class="">Case Studies</span>
            </a>
            <a class="nav-v2-menu-item nav-v2-menu-item--dark" mat-menu-item>
              <span class="">Reports</span>
            </a>
            <a class="nav-v2-menu-item nav-v2-menu-item--dark" mat-menu-item>
              <span class="">Articles</span>
            </a>
          </div>
        </mat-menu>
      </div> -->
      <div class="nav-menu-outer">
        <button
          class="nav-menu-trigger nav-menu-trigger--dark"
          [matMenuTriggerFor]="companyMenu"
          #company="matMenuTrigger"
        >
          <div class="gap-6">
            <span class="">Company</span>
            <mat-icon class="material-icons-outlined filter-mat-icon">
              {{ company.menuOpen ? "expand_less" : "expand_more" }}
            </mat-icon>
          </div>
        </button>
        <mat-menu class="nav-v2-menu-panel-dark" #companyMenu="matMenu">
          <div class="nav-v2-menu-inner">
            <a
              href="/aboutus"
              class="nav-v2-menu-item nav-v2-menu-item--dark"
              mat-menu-item
            >
              <span class="">About us</span>
            </a>
            <!-- <a class="nav-v2-menu-item nav-v2-menu-item--dark" mat-menu-item>
              <span class="">Leadership</span>
            </a>
            <a class="nav-v2-menu-item nav-v2-menu-item--dark" mat-menu-item>
              <span class="">News</span>
            </a> -->
          </div>
        </mat-menu>
      </div>
    </div>
    <div class="nav-buttons-container">
      <a
        [className]="
          darkNav
            ? 'nav-button nav-button--darkBtn'
            : 'nav-button nav-button--light'
        "
        href="/contact-us"
      >
        Talk to us
      </a>
      <a
        [className]="darkNav ? 'nav-button nav-button--dark' : 'nav-button'"
        href="/auth/sign-in"
      >
        Sign in
        <svg
          *ngIf="!darkNav"
          width="18"
          height="19"
          viewBox="0 0 18 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.75 2.75H12.75C13.1478 2.75 13.5294 2.90804 13.8107 3.18934C14.092 3.47064 14.25 3.85218 14.25 4.25V14.75C14.25 15.1478 14.092 15.5294 13.8107 15.8107C13.5294 16.092 13.1478 16.25 12.75 16.25H6.75M11.25 9.5L8.25 6.5M11.25 9.5L8.25 12.5M11.25 9.5H3.75"
            stroke="#FAF2F2"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <svg
          *ngIf="darkNav"
          width="18"
          height="19"
          viewBox="0 0 18 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.75 2.75H12.75C13.1478 2.75 13.5294 2.90804 13.8107 3.18934C14.092 3.47064 14.25 3.85218 14.25 4.25V14.75C14.25 15.1478 14.092 15.5294 13.8107 15.8107C13.5294 16.092 13.1478 16.25 12.75 16.25H6.75M11.25 9.5L8.25 6.5M11.25 9.5L8.25 12.5M11.25 9.5H3.75"
            stroke="#000614"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </a>
    </div>
    <button (click)="toggleMenu()" class="nav-v2-menu-button">
      <svg
        *ngIf="!isOpen && !darkNav"
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line y1="7.25" x2="25" y2="7.25" stroke="#FAF2F2" stroke-width="1.5" />
        <line
          y1="16.25"
          x2="25"
          y2="16.25"
          stroke="#FAF2F2"
          stroke-width="1.5"
        />
      </svg>

      <svg
        *ngIf="!isOpen && darkNav"
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line y1="7.25" x2="25" y2="7.25" stroke="#000614" stroke-width="1.5" />
        <line
          y1="16.25"
          x2="25"
          y2="16.25"
          stroke="#000614"
          stroke-width="1.5"
        />
      </svg>

      <span *ngIf="isOpen" class="nav-v2-menu-button-opened">
        Close
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"
            fill="#FAF2F2"
          />
        </svg>
      </span>
    </button>
  </nav>
  <section data-lenis-prevent class="nav-menu-responsive" *ngIf="isOpen">
    <video autoplay muted loop playsinline id="hero-video" preload="metadata">
      <source
        src="https://res.cloudinary.com/djqsg8e9k/video/upload/v1690318831/wave_eu7sxt.mp4#t=0.5"
        type="video/mp4"
      />
    </video>
    <div class="nav-menu-responsive--outer">
      <div class="nav-menu-responsive--outer--item" style="padding-top: 100px">
        <h3 class="nav-menu-responsive--outer--item--header">Solutions</h3>
        <a
          class="nav-menu-responsive--outer--item--nav"
          href="/solutions/marketplace"
        >
          Marihub Marketplace
        </a>
        <!-- <a
          class="nav-menu-responsive--outer--item--nav"
          href="/solutions/bluepass"
        >
          BluePass
        </a> -->
      </div>
      <div class="separator"></div>

      <!-- <div class="nav-menu-responsive--outer--item">
        <h3 class="nav-menu-responsive--outer--item--header">Resources</h3>
        <a
          class="nav-menu-responsive--outer--item--nav"
          href="/MarihubMarketplace"
        >
          Case Studies
        </a>
        <a class="nav-menu-responsive--outer--item--nav" href="/BluePass">
          Reports
        </a>
        <a class="nav-menu-responsive--outer--item--nav" href="/BluePass">
          Articles
        </a>
      </div> -->
      <div class="separator"></div>
      <div class="nav-menu-responsive--outer--item">
        <h3 class="nav-menu-responsive--outer--item--header">Company</h3>
        <a class="nav-menu-responsive--outer--item--nav" href="/aboutus">
          About us
        </a>
        <!-- <a class="nav-menu-responsive--outer--item--nav" href="/">
          Leadership
        </a>
        <a class="nav-menu-responsive--outer--item--nav" href="/BluePass">
          News
        </a> -->
      </div>
    </div>
    <div class="underlay"></div>
  </section>
</header>
